import { ComponentPropsWithoutRef, ForwardedRef, forwardRef } from 'react';
import { Button } from '@givebutter/primitives/button';
import { twJoin } from 'tailwind-merge';

interface HeaderButtonProps extends Omit<ComponentPropsWithoutRef<'button'>, 'color'> {}

const HeaderButton = forwardRef(
    ({ className, ...rest }: HeaderButtonProps, ref: ForwardedRef<HTMLButtonElement>) => {
        return (
            <Button
                variant="outline"
                size="sm"
                color="neutral"
                className={twJoin(
                    'h-10 bg-opacity-10 text-white ring-gray-600 [&>svg]:text-white',
                    'hover:bg-opacity-20 focus:bg-opacity-20 focus-visible:bg-opacity-20',
                    className,
                )}
                ref={ref}
                {...rest}
            />
        );
    },
);

export { HeaderButton };
